import React, { useEffect, useMemo, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { AppDispatch } from "../../../core/data/redux/store";
import { useDispatch, useSelector } from "react-redux";
import DeleteModal1 from "../../../core/modals/deleteModal1";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { Drawer, message } from "antd";
import { decryptData } from "../../../core/utils/encryptUtils";
import { createexperience, fetchingexperience, Updateexperience, DeleteExperience } from "../../../core/data/redux/experience/experience.Action";
import { exportToCSV, exportToExcel, exportToPDF } from "../../../core/common/GlobalFunctions/exportTableData";

type FormDataType = {
  label: string;
  timePeriod: string;
  status: string;
};

const Experience = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [tableKey, setTableKey] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [modalType, setModalType] = useState<"edit" | "create" | "">("");
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const { user } = useSelector((state: any) => state.auth);
  const [errors, setErrors] = useState<any>({});
  const [formData, setFormData] = useState<FormDataType>({
    label: "",
    timePeriod: "",
    status: "",
  });
  const { experiences } = useSelector((state: any) => state.experience);

  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];


  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");

  const showModal = (type: "edit" | "create") => {
    setModalType(type);
    setIsModalVisible(true);
    setErrors({});
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType("");
    setErrors({});
  };

  const handleEditDesignation = (record: any): void => {
    setSelectedRowData(record);
    setErrors({});
  };

  const handleEditSkill = (record: any): void => {
    setSelectedRowData(record);
  };

  const handleDeleteSkill = (Id: any) => {
    const skillId = Id;
    dispatch(DeleteExperience(skillId))
      .then((resp: any) => {
        if (resp.meta.requestStatus === "fulfilled") {
          message.success(resp.payload.message);
          setIsDeleteModalVisible(false);
          dispatch(fetchingexperience())
        } else {
          setIsDeleteModalVisible(false);
          message.success(resp.payload.error);
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };



  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "noOfDays" ? parseInt(value, 10) : value,
    }));
  };


  const validateForm = () => {
    const newErrors: any = {};

    if (!formData.label.trim()) {
      newErrors.label = "Level is required.";
    }

    if (!formData.timePeriod.trim()) {
      newErrors.timePeriod = "Time period is required.";
    }

    if (!formData.status) {
      newErrors.status = "Status is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;

    const userId = user.UserId;

    const payload = {
      ...formData,
      ...(modalType === "edit"
        ? { modifiedBy: userId }
        : { createdBy: userId }),
    };


    if (modalType === "edit") {
      dispatch(Updateexperience({ data: payload, Id: selectedRowData.Id }))
        .then((res) => {
          message.success(res.payload.message)
          dispatch(fetchingexperience())
          setIsModalVisible(false);
        })
    } else {
      dispatch(createexperience(payload)).then((res) => {
        message.success(res.payload.message)
        setIsModalVisible(false);
        dispatch(fetchingexperience())
      });
    }
  };



  useEffect(() => {
    dispatch(fetchingexperience())
  }, [dispatch]);

  useEffect(() => {
    if (modalType === "edit" && selectedRowData) {
      setFormData({
        label: selectedRowData.Label || "",
        timePeriod: selectedRowData.TimePeriod || "",
        status: selectedRowData.Status || "",
      });
    }
  }, [selectedRowData, modalType]);


  // eslint-disable-next-line react-hooks/exhaustive-deps
  const data = experiences ?? [];

  const filteredData = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { Status: selectedStatus }
        : {};
    return filterData(
      data || [],
      filters,
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [data, selectedStatus, selectedSort]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [experiences, selectedSort, selectedStatus, dispatch]);

  const columns = [
    {
      title: "Level",
      dataIndex: "Label",
      sorter: (a: any, b: any) => a.Label.localeCompare(b.Label),
      render: (text: string) => <span className="fw-medium">{text}</span>,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string) => (
        <span
          className={`badge ${text === "active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}

        </span>
      ),
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: any, record: any) => (
        <div className="action-icon d-inline-flex">
          {/* Edit Button with Permission Check */}
          <button
            className="me-2"
            onClick={() => {
              if (!canEdit) return;
              showModal("edit");
              handleEditDesignation(record);
            }}
            disabled={!canEdit}
            style={{
              cursor: canEdit ? "pointer" : "not-allowed",
              opacity: canEdit ? 1 : 0.5,
            }} data-bs-toggle="tooltip"
            data-bs-placement="top"

            title={!canEdit ? "Permission Denied" : "Edit "}
          >
            <i className="ti ti-edit" />
          </button>

          {/* Delete Button with Permission + Status Check */}
          <button
            onClick={() => {
              if (!canDelete || record.Status === "inactive") return;
              setSelectedRowData(record);
              handleEditSkill(record);
              setIsDeleteModalVisible(true);
            }}
            className="me-2"
            disabled={!canDelete || record.Status === "inactive"}
            style={{
              cursor:
                !canDelete || record.Status === "inactive"
                  ? "not-allowed"
                  : "pointer",
              opacity: !canDelete || record.Status === "inactive" ? 0.5 : 1,
            }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"

            title={
              !canDelete
                ? "Permission Denied"
                : record.Status === "inactive"
                  ? "Inactive Record"
                  : "Delete Record"
            }
          >
            <i className="ti ti-trash" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Experience</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Employee</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Experience
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data, "Experience_data")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(data, "Experience_data")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToPDF(data, "Experience_data")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as PDF{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              {canAdd && (
                <div className="mb-2">
                  <button
                    onClick={() => {
                      showModal("create");
                      setFormData({
                        label: "",
                        timePeriod: "",
                        status: "",
                      })
                    }}
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Experience
                  </button>
                </div>
              )}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5> Experience list</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  {/* <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Department
                  </Link> */}
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Finance
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Application Development
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("active")}
                        className="dropdown-item rounded-1"
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("inactive")}
                        className="dropdown-item rounded-1"
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Designation */}
      <Drawer
        title={modalType === "edit" ? "Edit Experience" : "Add Experience"}
        placement="right"
        width={600}
        onClose={handleCancel}
        visible={isModalVisible}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form onSubmit={handleSubmit}>
          <div className="modal-body pb-0">
            <div className="row">
              {/* Label */}
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Level <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="label"
                    value={formData.label}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                  {errors.label && <div style={{ color: "red" }}>{errors.label}</div>}
                </div>
              </div>

              {/* Time Period */}
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Time Period <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="timePeriod"
                    value={formData.timePeriod}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                  {errors.timePeriod && (
                    <div style={{ color: "red" }}>{errors.timePeriod}</div>
                  )}
                </div>
              </div>

              {/* Status */}
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="status"
                    value={formData.status}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                  {errors.status && (
                    <div style={{ color: "red" }}>{errors.status}</div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <button type="button" className="btn btn-light me-2" onClick={handleCancel}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" >
              {modalType === "edit" ? "Update Experience" : "Add Experience"}
            </button>
          </div>
        </form>
      </Drawer>

      {/* /Add Designation */}

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.Id &&
          handleDeleteSkill(selectedRowData?.Id)
        }
      />
    </>
  );
};
export default Experience;
